<template>
  <div id="app" class="flex  bg-pampas flex-col">
    <section
      v-if="!loginPage"
      class="
        mobile-menu
        fixed
        md:hidden
        print:hidden
        inset-x-0
        bottom-0
        z-50
        bg-white
        shadow-lg
        border

      "
    >
      <div class="flex justify-between ">
        <div
          class="w-full justify-center inline-block text-center pt-2 pb-1"
          v-for="(table, index) in $root.cache.tables"
          v-if="table.location == 1"
          :key="table.id"
        >
          <template v-if="table.url">
            <router-link :to="{ name: table.url, params: { index } }">
              <vk-icon
                class="text-black"
                ratio="1"
                style="color:black"
                :icon="table.icon"
              ></vk-icon>
              <span class="tab tab-home text-black block text-xs">{{
                table.name
              }}</span>
            </router-link>
          </template>
          <template v-else>
            <router-link
              :to="{ name: 'list', params: { index, table: table.table } }"
            >
              <vk-icon
                ratio="1"
                style="color:black"
                class="text-black"
                :icon="table.icon"
              ></vk-icon>
              <span class="tab tab-home text-black block text-xs">{{
                table.name
              }}</span>
            </router-link>
          </template>
        </div>
      </div>
    </section>
    <BottomMessage />
    <AppHeadNavbar
      :favorites="favorites"
      :userName="userName"
      :sidebarNotes="sidebarNotes"
      :notifications="notifications"
      :notificationCount="notificationCount"
      :userID="userID"
      v-if="theme == 'head_navbar'"
      @openFavoritesDrawer="favoritesDrawerShow = true"
    />
    <DefaultTheme
      :favorites="favorites"
      :userName="userName"
      :sidebarNotes="sidebarNotes"
      :notificationCount="notificationCount"
      :notifications="notifications"
      :userID="userID"
      v-else
      @openFavoritesDrawer="favoritesDrawerShow = true"
    />

    <!-- Favorites Drawer -->
    <FavoritesDrawer
      :show="favoritesDrawerShow"
      :favorites="favorites"
      @close="favoritesDrawerShow = false"
      @remove="removeFavorite"
    />

    <!-- Listeden açılan lead kartı (iki temada da ortak) -->
    <LeadQuickView v-if="!loginPage" />
  </div>
</template>
<script>
import AuthService from "./services/auth";
import AppHeadNavbar from "./App.HeadNavbar.vue";
import DefaultTheme from "./App.Default.vue";
import EventBus from "./components/Ui/EventBus";
import BottomMessage from "./components/BottomMessage.vue";
import FavoritesDrawer from "./components/Ui/FavoritesDrawer.vue";
import LeadQuickView from "./components/Ui/Lead/LeadQuickView.vue";
import Config from "./config";
import http from "./services/http";
import realtime from "./services/realtime";
import notificationStore from "./services/notificationStore";
import notificationDebug from "./services/notificationDebug";
import desktopNotify from "./services/desktopNotify";
import clientLog, { safeKey } from "./services/clientLog";
export default {
  components: {
    BottomMessage,
    AppHeadNavbar,
    DefaultTheme,
    FavoritesDrawer,
    LeadQuickView,
  },
  data() {
    return {
      messages: [],
      mobileShow: false,
      menuNameShow: true,
      messagesType: "primary",
      loginPage: true,
      userName: null,
      userID: null,
      loading: true,
      sidebarProfile: false,
      themeBackground: null,
      searchValue: null,
      routeSelected: this.$route.params.index,
      searchTable: "leads",
      sidebarNotes: [],
      favoriteShow: false,
      sidebarNoteShow: false,
      show: false,
      isOpen: false,
      notificationList: false,
      results: [],
      search: "",
      themeStyle: 1,
      theme: "default",
      themeDark: false,
      themeMenuShow: 250,
      isLoading: false,
      favorites: [],
      favoritesDrawerShow: false,
      notificationPollTimer: null,
      notificationHealthTimer: null,
      notificationsStarted: false,
      // Tüm sekmelerin aynı saniyede sunucuya yüklenmemesi için sekme başına
      // sabit, rastgele bir kayma.
      notificationPollJitter: Math.floor(Math.random() * 10000),
      arrowCounter: -1,
    };
  },
  created() {
    this.loading = false;
    this.checkLoginPage();
    this.themeBackground = localStorage.themeBackground;
    if (localStorage.themeStyle) {
      this.themeStyle = localStorage.themeStyle;
    }
    if (localStorage.themeDark) {
      this.themeDark = localStorage.themeDark;
    }
    if (localStorage.theme) {
      this.theme = localStorage.theme;
    }

    this.userName = localStorage.userName;
    this.userID = localStorage.userId;
    const sidebarNoteShow = localStorage.getItem("sidebarNoteShow");
    if (sidebarNoteShow == "true") {
      this.sidebarNoteShow = true;
    }
    const favoriteShow = localStorage.getItem("favoriteShow");
    if (favoriteShow == "true") {
      this.favoriteShow = true;
    }
    http.getSidebarNotes().then((resp) => {
      this.sidebarNotes = resp.data;
    });
    this.getFavorites();
    window.addEventListener("keydown", function(event) {
      if (event.key === "k" && event.ctrlKey === true) {
        EventBus.$emit("topSearchFocus");
      }
    });
  },
  computed: {
    // Tek doğruluk kaynağı store; liste ve rozet her senkronda birlikte güncellenir.
    notifications() {
      return notificationStore.state.items;
    },
    notificationCount() {
      return notificationStore.state.unreadCount;
    },
  },
  watch: {
    $route(to) {
      if (to.meta.location == 1) {
        this.routeSelected = to.params.index;
      }
      // Oturum düşüp giriş sayfasına yönlendirildiyse eski kullanıcının
      // kanalı ve 401 alan yoklama kapatılır. Girişten sonra sayfa baştan
      // yüklendiği için yeniden başlatmaya gerek yok.
      // (requiresAuth:false yetmez: /notfound da öyle, oturum açıkken de gelinir.)
      if (to.name === "login") this.stopNotifications();
    },
    searchTable() {
      this.searchSubmit();
    },
    searchValue(data) {
      if (data == "") {
        setTimeout(() => {
          this.show = false;
        }, 5000);
      }
    },
  },
  methods: {
    unmuteNotification(keyword) {
      notificationStore.removeMutedKeyword(keyword);
    },
    muteNotification(keyword) {
      notificationStore.addMutedKeyword(keyword);
    },
    isNotificationMuted(notification) {
      return notificationStore.isMuted(notification);
    },

    // --- Bildirim bağlantısı -------------------------------------------------
    startNotifications() {
      if (this.notificationsStarted) return;
      this.notificationsStarted = true;
      this.stopStateListener = realtime.onStateChange((current) => {
        notificationStore.setConnectionState(current);
        // Her (yeniden) bağlanmada kopukluk sırasında kaçan kayıtlar çekilir.
        // Watchdog dakikada birkaç kez yeniden bağlanabildiği için kısa bir
        // alt sınır var; hata backoff'u yine atlanır.
        if (current === "connected") {
          notificationStore.sync({ urgent: true, minAge: 8000 });
        }
      });

      // focus + visibilitychange + online olayları peş peşe tetiklenir ve
      // temsilciler gün boyu sekme değiştirir. Her olayda istek atmak yerine
      // son senkronun üzerinden 30 sn geçmişse yenilenir.
      this.stopResumeListener = realtime.onResume(() => {
        notificationStore.sync({ minAge: 30000 });
      });

      this.stopMissedListener = notificationStore.onMissed((items) =>
        this.announceMissed(items)
      );

      // İzin artık açılışta değil, ilk tıklamada / panel düğmesiyle istenir.
      desktopNotify.watch();
      desktopNotify.armFirstClickPrompt();

      this.subscribePrivate(
        "notification_" + Config.PUSHER_CHNL_ID + "_" + this.userID,
        this.handleNotificationMessage
      );

      const excelId = localStorage.excelUploadId;
      if (excelId) {
        this.subscribePrivate(
          "excelupload_" + Config.PUSHER_CHNL_ID + "_" + excelId,
          this.handleExcelMessage
        );
      }

      EventBus.$on("excelUploadId", (excelUploadId) => {
        this.subscribePrivate(
          "excelupload_" + Config.PUSHER_CHNL_ID + "_" + excelUploadId,
          this.handleExcelMessage
        );
      });

      notificationStore.setConnectionState(realtime.getState());
      // İlk yükleme: liste boş olduğu için kısıtsız.
      notificationStore.sync({ force: true });
      this.startNotificationPolling();

      // Bağlantı oturduktan sonra tek satırlık durum özeti: şikâyet eden
      // kullanıcının ID'siyle logda aranınca sebep doğrudan görünür.
      // Sayfa yenilemelerinde tekrar gitmez; durum değişirse ya da 6 saatte
      // bir gönderilir.
      clearTimeout(this.notificationHealthTimer);
      this.notificationHealthTimer = setTimeout(() => {
        const health = desktopNotify.health();
        delete health.visibility;
        delete health.askedAt;
        clientLog.infoIfChanged(
          "notify.health",
          Object.assign(health, {
            connection: realtime.getState(),
            mutedCount: notificationStore.state.mutedKeywords.length,
            lastSyncOk: !!notificationStore.state.lastSyncAt,
          }),
          6 * 3600 * 1000
        );
      }, 15000);
    },

    // Kanallar private- (abonelik için /pusher/auth imzası gerekir); öneksiz
    // kanallar herkese açıktı. İmza alınamazsa geçiş süresince eski kanal yedek.
    subscribePrivate(name, handler) {
      realtime.subscribe("private-" + name, "message", handler, {
        fallbackChannel: name,
      });
    },

    stopNotifications() {
      if (!this.notificationsStarted) return;
      this.notificationsStarted = false;
      clearInterval(this.notificationPollTimer);
      clearTimeout(this.notificationHealthTimer);
      if (this.stopStateListener) this.stopStateListener();
      if (this.stopResumeListener) this.stopResumeListener();
      if (this.stopMissedListener) this.stopMissedListener();
      EventBus.$off("excelUploadId");
      realtime.stop();
    },

    // Websocket tamamen çalışmasa bile liste ve rozet güncel kalsın diye
    // arka planda çalışan güvenlik ağı.
    startNotificationPolling() {
      clearInterval(this.notificationPollTimer);
      this.notificationPollTimer = setInterval(() => {
        // Arka plandaki sekme sunucuya yük bindirmesin. Sekme öne geldiğinde
        // realtime.onResume zaten bir senkron tetikliyor.
        if (typeof document !== "undefined" && document.hidden) return;

        const connected = realtime.getState() === "connected";
        const age = Date.now() - (notificationStore.state.lastSyncAt || 0);
        const threshold =
          (connected ? 60000 : 20000) + this.notificationPollJitter;
        if (age < threshold) return;

        // minAge kardeş sekmeleri de kapsar: aynı kullanıcının 3 sekmesi
        // açıkken sunucuya 3 değil 1 istek gider.
        notificationStore.sync({ minAge: connected ? 45000 : 15000 });
      }, 20000);
    },

    handleNotificationMessage(message) {
      notificationDebug("app: bildirim handler'ı çağrıldı", message);
      // Pusher payload'u kaydın tamamını taşıyor (id, start, lead_name...),
      // bu yüzden mesaj başına ek bir /notifications isteği atılmaz. Kaçırılan
      // kayıtları yakalamak periyodik poll'un işi.
      const item = notificationStore.ingest(message);

      // null => daha önce görülmüş ya da sessize alınmış bildirim.
      if (!item) return;
      this.announceNotification(item, "live");
    },

    // Senkronda bulunan, canlı gelmemiş bildirimler (kopukluk anına denk
    // gelenler). Az ise tek tek, çoksa tek bir özetle duyurulur.
    announceMissed(items) {
      if (items.length <= 3) {
        items.forEach((item) => this.announceNotification(item, "sync"));
        return;
      }
      EventBus.$emit("bottomMessage", {
        open: true,
        key: "missed-summary",
        type: "info",
        title: "Bildirimler",
        body:
          items.length +
          " bildirim bağlantı koptuğu sırada geldi, listeden görebilirsiniz.",
      });
      desktopNotify
        .show({
          key: "missed-summary",
          title: "Bildirimler",
          body: items.length + " yeni bildirim",
        })
        .then((desktop) => {
          items.forEach((item) =>
            this.logReceived(item, "sync-summary", desktop)
          );
        });
    },

    // via: live (Pusher) | sync (senkronda bulundu) | sync-summary
    announceNotification(item, via) {
      // key: aynı bildirim ikinci kez gelirse yeni toast açmak yerine açık
      // olan güncellenir; toast başka bir toast'ın yerine asla silinemez.
      if (item.lead_name) {
        EventBus.$emit("bottomMessage", {
          open: true,
          key: item.key,
          type: "info",
          title: item.lead_name,
          body: item.body,
          url: item.lead_id
            ? { label: "Detay", url: "/leadDetail/" + item.lead_id }
            : undefined,
        });
      } else {
        EventBus.$emit("bottomMessage", {
          open: true,
          key: item.key,
          type: "info",
          title: item.title,
          body: item.body,
        });
      }

      desktopNotify
        .show(item, () => {
          // Zaten o lead'deyken tıklanırsa router NavigationDuplicated ile
          // reddeder; beklenen bir durum.
          if (item.lead_id) {
            this.$router
              .push("/leadDetail/" + item.lead_id)
              .catch(() => {});
          }
        })
        .then((desktop) => this.logReceived(item, via, desktop));
    },

    logReceived(item, via, desktop) {
      // Sunucudaki "pusher_sent" kaydıyla id üzerinden eşleşir.
      clientLog.info(
        "notify.received",
        {
          id: item.id,
          key: safeKey(item.key),
          start: item.start,
          hidden: document.hidden,
          desktop,
          via,
        },
        { dedup: false }
      );
    },

    handleExcelMessage(message) {
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "upload",
        count: message,
        title: "Veriler yüklendi",
        body: " (" + message[0] + ") tane kayıt başarılı olarak yüklendi",
      });
    },
    reload() {
      EventBus.$emit("reflesh", true);
    },
    getFavorites() {
      http.getFavorites().then((resp) => {
        this.favorites = resp.data;
      });
    },
    removeFavorite(id) {
      http.removeFavorite(id).then(() => {
        this.getFavorites();
      });
    },

    sidebarNoteToggle() {
      this.sidebarNoteShow = !this.sidebarNoteShow;
      localStorage.sidebarNoteShow = this.sidebarNoteShow;
    },
    favoriteToggle() {
      this.favoriteShow = !this.favoriteShow;
      localStorage.favoriteShow = this.favoriteShow;
    },
    logout() {
      AuthService.logout().then(() => {
        this.$router.push("logout");
      });
    },
    checkLoginPage() {
      if (this.$route.meta.requiresAuth == false) {
        this.loginPage = true;
      } else {
        this.loginPage = false;
      }
    },
    onChange() {
      // Let's warn the parent that a change was made
      this.$emit("input", this.search);
      // Let's  our flat array
      this.filterResults();
      this.isOpen = true;
    },
    setResult(result) {
      this.search = result;
      this.isOpen = false;
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.searchValue = this.results[this.arrowCounter];
      this.isOpen = false;
      this.arrowCounter = -1;
    },
  },
  beforeDestroy() {
    this.stopNotifications();
    EventBus.$off("newMutedKeywords");
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  mounted() {
    this.$root.isMobile();
    // İlk rota çözülmeden $route boştur; giriş sayfası ancak onReady'de
    // ayırt edilir. Oturumu düşmüş kullanıcı /login'deyken eski userId ile
    // kanala abone olup /notifications'a 401 almasın.
    this.$router.onReady(() => {
      if (this.$route.name === "login") return;
      // userId, router'daki loginValidate'te yazılır; created() onu bitmeden
      // okuyordu. Yeni girişte boş kalıyor (kanala hiç abone olunmuyordu), aynı
      // tarayıcıda kullanıcı değişince ÖNCEKİ kullanıcının kanalına abone
      // olunuyordu. onReady'de doğrulama tamamlanmıştır.
      this.userID = localStorage.userId;
      if (this.userID > 0) {
        this.startNotifications();
      } else if (localStorage.authToken) {
        // Oturum var ama userId yok: bildirim kanalına hiç abone olunmaz.
        clientLog.error("notify.no_user", { message: "userId missing" });
      }
    });

    EventBus.$on("newMutedKeywords", () => {
      notificationStore.reloadMutedKeywords();
    });

    this.routeSelected = this.$router.history.current.params.index || 0;
    this.$on("loading", (data) => {
      this.loading = data;
    });
    EventBus.$on("loading", (data) => {
      this.loading = data;
    });
    this.$on("logon", () => {
      this.checkLoginPage();
    });
    EventBus.$on("userName", (e) => {
      this.userName = e;
    });
    EventBus.$on("themeBackground", (e) => {
      this.themeBackground = e;
    });
    EventBus.$on("themeStyle", (e) => {
      this.themeStyle = e;
    });

    EventBus.$on("clickShowLog", (e) => {
      console.log(e.data, "click log geldi");
    });

    EventBus.$on("themeDark", (e) => {
      this.themeDark = e;
    });
    EventBus.$on("themeMenuShow", (e) => {
      this.themeMenuShow = e;
    });
    EventBus.$on("sidebarNoteShow", (e) => {
      this.sidebarNoteShow = e;
    });
    EventBus.$on("favoritesLoad", () => {
      this.getFavorites();
    });
  },
};
</script>
